import { useEffect } from 'react';
import { useLive, useServices, type HyloServices, type Live } from '@/model';
import { acknowledgedCapabilities } from '@/core/hooks';

export interface AgentCapabilities { support: boolean; conditionalStop: boolean }
const bindings = new WeakMap<HyloServices, { source: Live<readonly string[]> }>();

function registerAgentCapabilities(services: HyloServices, source: Live<readonly string[]>) {
  const binding = { source }; bindings.set(services, binding);
  return () => { if (bindings.get(services) === binding) bindings.delete(services); };
}

/** The login startup outlet binds Core's actual Live, without copying or retaining old admission. */
export function AgentStartupRuntime() {
  const services = useServices();
  useEffect(() => registerAgentCapabilities(services, acknowledgedCapabilities(services.http)), [services]);
  return null;
}

/** Core owns account/connection admission. Numeric protocol and a declaration alone admit nothing. */
export function useAgentCapabilities(): AgentCapabilities {
  const services = useServices();
  const acknowledged = useLive(bindings.get(services)?.source ?? acknowledgedCapabilities(services.http));
  return { support: acknowledged.includes('support.v1'), conditionalStop: acknowledged.includes('stop.expected_run.v1') };
}
